import { isEmpty } from '../../utils/utils';

const state = {
    accessToken: window.localStorage.getItem('accessToken'),
    company: JSON.parse(window.localStorage.getItem('company')) || null,
    userPermissions: JSON.parse(window.localStorage.getItem('userPermissions')) || {},
    role: JSON.parse(window.localStorage.getItem('role')) || ''
};

const mutations = {
    'SET_ACCESS_TOKEN' (state, accessToken) {
        state.accessToken = accessToken;
        if (accessToken === null || accessToken === undefined) {
            window.localStorage.removeItem('accessToken');
        } else {
            window.localStorage.setItem('accessToken', accessToken);
        }
    },
    'DELETE_ACCESS_TOKEN' (state) {
        state.accessToken = null;
        window.localStorage.removeItem('accessToken')
    },
    'SET_COMPANY' (state, company) {
        state.company = company;
        window.localStorage.setItem('company', JSON.stringify(company));
    },
    'DELETE_COMPANY' (state) {
        state.company = null;
        window.localStorage.removeItem('company');
    },
    'SET_USER_PERMISSIONS' (state, userPermissions) {
        state.userPermissions = userPermissions;
    },
    'SET_STORE_USER_PERMISSIONS' (state, userPermissions) {
        state.userPermissions = userPermissions;
        window.localStorage.setItem('userPermissions', JSON.stringify(userPermissions));
    },
    'DELETE_USER_PERMISSIONS' (state) {
        state.userPermissions = {};
        window.localStorage.removeItem('userPermissions');
    },
    'SET_ROLE' (state, role) {
        state.role = role;
        window.localStorage.setItem('role', JSON.stringify(role));
    },
    'DELETE_ROLE' (state) {
        state.role = null;
        window.localStorage.removeItem('role');
    },
};

const actions = {
    setAccessToken({ commit }, accessToken) {
        commit('SET_ACCESS_TOKEN', accessToken);
    },
    deleteAccessToken({ commit }) {
        commit('DELETE_ACCESS_TOKEN');
    },
    setCompany({ commit }, company) {
        if (undefined !== company && !isEmpty(company)) {
            commit('SET_COMPANY', company);
        }
    },
    deleteCompany({ commit }) {
        commit('DELETE_COMPANY');
    },
    setUserPermissions({ commit }, userPermissions) {
        commit('SET_USER_PERMISSIONS', userPermissions);
    },
    setStoreUserPermissions({ commit }, userPermissions) {
        commit('SET_STORE_USER_PERMISSIONS', userPermissions);
    },
    deleteUserPermissions({ commit }) {
        commit('DELETE_USER_PERMISSIONS');
    },
    setRole({ commit }, role) {
        commit('SET_ROLE', role);
    },
    deleteRole({ commit }) {
        commit('DELETE_ROLE');
    },
};

const getters = {
    accessToken: state => state.accessToken,
    company: state => state.company,
    userPermissions: state => state.userPermissions,
    role: state => state.role
};

export default {
    state,
    mutations,
    actions,
    getters
};